import { Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { StoreService } from '@root/shared/service/store.service';
import { TujiaAutoReceiptService } from './tujia-auto-receipt.service';

export const key = 'hostex_tujia_auto_receipt';

@Component({
  selector: 'host-tujia-auto-receipt',
  templateUrl: './tujia-auto-receipt.component.html',
  styleUrls: ['./tujia-auto-receipt.component.scss'],
  providers: [TujiaAutoReceiptService]
})
export class TujiaAutoReceiptComponent implements OnInit {
  checked = false;
  constructor(
    private storeService: StoreService,
    private modalRef: NzModalRef,
    private messageService: NzMessageService,
    private autoReceiptService: TujiaAutoReceiptService
  ) {}

  ngOnInit() {}

  onCancel() {
    this.storeService.set(key, this.checked, 2);
    this.destroy();
  }

  onConfirm() {
    this.storeService.set(key, this.checked, 2);
    this.requestSetAutoReceipt();
  }

  private requestSetAutoReceipt() {
    this.autoReceiptService
      .setAutoAcceptReservation({ status: 1 })
      .subscribe(res => {
        if (res.error_code === 0) {
          this.messageService.success('设置成功');
          this.destroy();
        }
      });
  }
  destroy() {
    this.modalRef.destroy();
  }
}
